import type { AvailableFiltersItemProps } from '@services/api/preview/types'

export const getInitialFilterValue = (options: AvailableFiltersItemProps[]): string => {
  if (!options || options.length === 0) return 'all'

  const todosOption = options.find((item) => {
    const isTodosByCode = item.code === 'all' || item.code?.toLowerCase() === 'all'
    const isTodosByName = item.name?.toLowerCase() === 'todos' || item.name === 'Todos'
    return isTodosByCode || isTodosByName
  })

  const optionsWithoutTodos = options.filter((item) => {
    const isTodosByCode = item.code === 'all' || item.code.toLowerCase() === 'all'
    const isTodosByName = item.name?.toLowerCase() === 'todos' || item.name === 'Todos'
    return !isTodosByCode && !isTodosByName
  })

  if (optionsWithoutTodos.length === 1) return optionsWithoutTodos[0].code

  return todosOption?.code || 'all'
}
